module.exports = __webpack_public_path__ + "img/med-c3.0a314415.svg";